<template>
  <v-dialog v-model="dialog" persistent max-width="460">
    <v-card>
      <v-card-text class="pb-0">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="overline">{{
                params.description
              }}</v-list-item-title>
              <v-list-item-subtitle class="caption"
                >Document No: {{ params.sourceDocumentNo }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="caption"
                >Payer ID: {{ params.payerID }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action
              class="overline primary-text font-weight-bold text-h4"
              >{{ params.amount | currency }}
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-divider />

      <v-card-title class="overline">
        Bill To
        <v-spacer />

        <v-menu offset-y>
          <template v-slot:activator="{ attrs, on }">
            <v-btn text small color="primary" v-bind="attrs" v-on="on">
              Change Address
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item-group>
              <v-list-item
                dense
                v-for="(item, i) in billingAddresses"
                :key="i"
                link
                @click="setAddress(item)"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ `${item.firstName} ${item.lastName} ` }}
                    {{
                      item.companyName ? `(${item.companyName})` : ""
                    }}</v-list-item-title
                  >
                  <v-list-item-subtitle>{{
                    `${item.country}, ${item.city}, ${item.postalCode}`
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </v-card-title>

      <v-card-text class="px-10">
        <v-simple-table dense class="caption text-left" v-if="billingAddress">
          <tr>
            <td>Name</td>
            <td>
              {{ billingAddress.firstName }} {{ billingAddress.lastName }}
            </td>
          </tr>
          <tr>
            <td>Email Address</td>
            <td>{{ billingAddress.email }}</td>
          </tr>
          <tr>
            <td>Phone Number</td>
            <td>{{ billingAddress.phone }}</td>
          </tr>
          <tr>
            <td>Company Name</td>
            <td>{{ billingAddress.companyName }}</td>
          </tr>
          <tr>
            <td>Address 1</td>
            <td>{{ billingAddress.address1 }}</td>
          </tr>
          <tr>
            <td>Address 2</td>
            <td>{{ billingAddress.address2 }}</td>
          </tr>
          <tr>
            <td>Country</td>
            <td>{{ billingAddress.country }}</td>
          </tr>
          <tr>
            <td>City</td>
            <td>{{ billingAddress.city }}</td>
          </tr>
          <tr>
            <td>Postal Code</td>
            <td>{{ billingAddress.postalCode }}</td>
          </tr>
        </v-simple-table>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn color="grey" text @click="cancel"> Cancel </v-btn>
        <v-btn color="primary" @click="confirm">
          Pay Now
          <v-icon right>mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { payGateCheckoutUrl } from "../../dashboard/environment";

export default {
  name: "checkoutComponent",
  data: function () {
    return {
      dialog: false,
      params: {
        payerID: "REF00001",
        sourceDocumentNo: "REG0001",
        description: "Exam Fees",
        amount: 1,
        accountNo: "",
        success_url: window.location.href,
        fail_url: window.location.href,
        onConfirm: () => {},
        onCancel: () => {},
      },
      billingAddress: null,
    };
  },

  mounted() {
    Event.$on("billing-checkout", (params) => {
      this.params = params;
      this.dialog = true;

      this.$store.dispatch("Billing/getBillingAddresses");
    });
  },

  computed: {
    billingAddresses() {
      const addresses = this.$store.getters["Billing/billingAddresses"];
      if (!this.billingAddress) this.setAddress(addresses[0]);

      return addresses;
    },
  },

  methods: {
    setAddress: function (address) {
      this.billingAddress = address;
    },

    hide: function () {
      this.dialog = false;
    },

    confirm: function () {
      let payload = { ...this.params };
      payload = btoa(JSON.stringify(payload));
      window.location.href = `${payGateCheckoutUrl}?payload=${payload}`;

      if (typeof this.params.onConfirm === "function") this.params.onConfirm();
      this.hide();
    },

    cancel: function () {
      if (typeof this.params.onCancel === "function") this.params.onCancel();
      this.hide();
    },
  },
};
</script>

<style scoped></style>
